import { Deps, useEffect, useMemo, useState } from "@lukekaalim/act";

const ASYNC_STATES = [
  'init',
  'started',
  'rejected',
  'resolved',
  'restarted'
] as const;

export const useAsync = <Result, Reject>(asyncFunc: () => Promise<Result>, deps: Deps = [], onReject: (reject: Reject) => void = console.warn) => {
  const [resolution, setResolution] = useState<{ result?: null | Result, reject?: null | Reject }>({ result: null, reject: null });
  const [state, setState] = useState<keyof typeof ASYNC_STATES>(0);

  useEffect(() => {
    setState(state => {
      if (state === 0)
        return 1;
      return 4;
    })
    asyncFunc()
      .then(
        result => (setResolution({ result }), setState(3)),
        reject => (setResolution({ reject }), setState(2), onReject && onReject(reject)),
      )
  }, deps);

  return useMemo(() => ({
    result: resolution.result,
    reject: resolution.reject,
    state: ASYNC_STATES[state],
  }), [state, resolution])
}